'use strict';

module.exports = function () {
    $('[data-bs-toggle="popover"]').popover();

    $('a[href] [data-bs-toggle="popover"]').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
};
